module.exports = __webpack_public_path__ + "static/media/star.5f2b2ae8.svg";